import dayjs from 'dayjs';

export const formatDate = (
  date: Date = new Date(),
  format: string = 'DD/MM/YYYY',
): string => {
  return dayjs(date).format(format);
};

export const FORMAT_DDMMMYYYY = 'DD MMM YYYY';
